import { render, staticRenderFns } from "./hotelCardOrder.vue?vue&type=template&id=59e56f60&scoped=true"
import script from "./hotelCardOrder.vue?vue&type=script&lang=js"
export * from "./hotelCardOrder.vue?vue&type=script&lang=js"
import style0 from "./hotelCardOrder.vue?vue&type=style&index=0&id=59e56f60&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e56f60",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3875257498/src/codestar-connections.ap-northeast-1.amazonaws.com/git-http/364953906322/ap-northeast-1/84d36ee7-16b8-4e80-bff0-7e6a249efe8b/OwlTing/owlnest_booking_engine/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59e56f60')) {
      api.createRecord('59e56f60', component.options)
    } else {
      api.reload('59e56f60', component.options)
    }
    module.hot.accept("./hotelCardOrder.vue?vue&type=template&id=59e56f60&scoped=true", function () {
      api.rerender('59e56f60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Payment/components/hotelCardOrder.vue"
export default component.exports